import styled from 'styled-components'
import { Radio } from 'antd'

const AntRadioStyled = styled(Radio)`
  &&& {
    .ant-radio .ant-radio-inner {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #d9d9d9;
      background-color: #fff;
      box-sizing: border-box;
    }

    .ant-radio .ant-radio-inner::after {
      width: 10px;
      height: 10px;
      margin-block-start: 0;
      margin-inline-start: 0;
      top: 50%;
      inset-inline-start: 50%;
      transform: translate(-50%, -50%) scale(0);
    }

    :hover {
      .ant-radio {
        .ant-radio-inner {
          border-color: ${props => props.theme.colors.color1.bg};
        }
        .ant-radio-inner::after {
          background-color: ${props => props.theme.colors.color1.bg};
        }
      }
    }
    .ant-radio-checked {
      .ant-radio-inner {
        border-color: ${props => props.theme.colors.color1.bg};
        background-color: #fff;
      }
      .ant-radio-inner::after {
        background-color: ${props => props.theme.colors.color1.bg};
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }
`

export default AntRadioStyled
